import PageRouteTracker from './analytics/PageRouteTracker';
import Routes from './Routes';

function App() {
  return (
    <>
      <PageRouteTracker />
      <Routes />
    </>
  );
}

export default App;